import React, { useState, useEffect, useCallback, useMemo,useRef } from 'react';
import { useMapStore } from '../store/mapStore';
import { STATUS } from '../types';

const CustomerStats = () => {
  const { locations,showLeads } = useMapStore();
  const isMobile = window.innerWidth <= 800;
  
  if (isMobile) return null;
  
  // Count locations by status
  const isSFLead = (r) => {
    const status = ((r.shipStatus ?? r.status) ?? '').toString().toLowerCase();
    const scope  = (r.scope ?? '').toString().trim().toUpperCase();
    return status === 'target' && scope === 'SALESFORCE';
  };
  
  const rows = showLeads
    ? locations
    : locations.filter(r => !isSFLead(r));
  
  const counts = rows.reduce((acc, loc) => {

    // if (location.scope === 'GOOGLE') {
    //   acc[STATUS.TARGET]++;
    //   return acc;
    // }

    if (loc.shipStatus.toLowerCase() === 'prospect') {
      acc[STATUS.PROSPECT]++;
    } else if (loc.shipStatus.toLowerCase() === 'active') {
        acc[STATUS.ACTIVE]++;
      } else if (loc.shipStatus.toLowerCase() === 'activeolder'){
        acc[STATUS.ACTIVE_OLDER]++;
      } else if (loc.shipStatus.toLowerCase() === 'target'){
        acc[STATUS.TARGET]++;}
      return acc;
    },
          {
    [STATUS.ACTIVE]: 0,
    [STATUS.ACTIVE_OLDER]: 0,
    [STATUS.PROSPECT]: 0,
    [STATUS.TARGET]: 0
  })
  
  return (
    <div>
        {counts && Object.keys(counts).length > 0 ?  
    
        <div className="stats-panel">
        <div className="flex items-center space-x-4">
          <div className="flex flex-col items-center">
            <span className="text-2xl font-bold text-green-600">
              {counts[STATUS.ACTIVE]}
            </span>
            <span className="text-fluid-sm font-medium">Ship &lt;= 52 Weeks</span>
          </div>
          
          <div className="h-10 w-px bg-gray-300"></div>
          
          <div className="flex flex-col items-center">
            <span className="text-2xl font-bold text-red-600">
              {counts[STATUS.ACTIVE_OLDER]}
            </span>
            <span className="text-fluid-sm font-medium">Ship &gt; 52 Weeks</span>
          </div>
          
          <div className="h-10 w-px bg-gray-300"></div>
          
          <div className="flex flex-col items-center">
            <span className="text-2xl font-bold text-blue-600">
              {counts[STATUS.PROSPECT]}
            </span>
            <span className="text-fluid-sm font-medium">Prospects</span>
          </div>
          
          <div className="h-10 w-px bg-gray-300"></div>
          
          <div className="flex flex-col items-center">
            <span className="text-2xl font-bold text-purple-600">
              {counts[STATUS.TARGET]}
            </span>
            <span className="text-fluid-sm font-medium">Targets</span>
          </div>
        </div>
      </div>
      : null
     }
    </div>
    

  );
};

export default CustomerStats;
